import DG_Modal from "../../../custom/feedback/modal";
import {useState} from "react";
import Update from "./update";


const EditParent = ({id, visible, onCancel, name})=>{

    const [loading , setLoading] = useState(false)

    return (
        <DG_Modal visible={visible}
                  width={900}
                  onCancel={() => onCancel()}
                  title={name}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Lưu"}
                  loading={loading}>
            <Update id={id}
                    onLoading={(value)=>setLoading(value)}
                    list={true}
                    onCancel={()=>onCancel()} />
        </DG_Modal>
    )
}
export default EditParent
